<template>
	<div>
		<BaseHeader :title="$t('templates').toString()"></BaseHeader>
		<div class="main">
			<div v-if="textTemplates && textTemplates.length">
				<div class="flex flex-col">
					<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
							<div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
								<table class="min-w-full divide-y divide-gray-200">
									<thead>
										<tr>
											<th class="px-6 py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider">
												{{ $t('name') }}
											</th>
										</tr>
									</thead>
									<tbody class="bg-white divide-y divide-gray-200">
										<TextTemplateRow v-for="text_template in textTemplates" :key="text_template.id" :text_template="text_template" />
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-else-if="!textTemplates" class="flex flex-grow justify-center w-full opacity-75">
				<LoadingSpinner />
			</div>

			<div v-else>{{ $t('no_entries_found') }}</div>
		</div>
	</div>
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import RouteWatcher from '@/mixins/RouteWatcher';
import { TextTemplatesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
import TextTemplateRow from '@/components/text_templates/TextTemplateRow';

export default {
	name: 'TextTemplates',
	components: { TextTemplateRow, LoadingSpinner, BaseHeader },
	mixins: [RouteWatcher],
	data() {
		return {
			textTemplates: null,
		};
	},
	methods: {
		onRouteChange() {
			this.requestTextTemplates();
		},
		requestTextTemplates() {
			TextTemplatesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.textTemplatesGet()
				.then(response => {
					this.textTemplates = response.data.data;
				});
		},
	},
};
</script>

<style scoped></style>
